'use client'

import { Divider, Spacer } from '@vinted/web-ui'
import { MouseEvent } from 'react'

import { useLocation } from '@marketplace-web/shared/browser'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { urlWithParams } from '@marketplace-web/shared/utils'
import {
  buildSubcatalogUrlParams,
  CatalogNavigationModel,
} from '@marketplace-web/domain/catalog-data'
import { selectCatalogEvent } from '_libs/common/event-tracker/events'
import { CatalogAttribute } from 'constants/catalog'
import { useCatalogContext } from 'pages/Catalog/CatalogProvider'

import useFetchDynamicFilters from '../../hooks/useFetchDynamicFilters'
import { useGetSubcatalogs } from '../../hooks/useGetSubcatalogs'

const SubcatalogNavigation = () => {
  const fetchDynamicFilters = useFetchDynamicFilters()
  const { track } = useTracking()
  const { searchParams } = useLocation()
  const {
    state: { filters, dynamicFilters },
  } = useCatalogContext()
  const { subCatalogs } = useGetSubcatalogs()
  const { selectedDynamicFilters } = dynamicFilters

  const urlParams = buildSubcatalogUrlParams({
    extraParams: searchParams,
    filters,
  })

  const handleClick = (catalog: CatalogNavigationModel) => (event: MouseEvent) => {
    event.preventDefault()

    const catalogIds = [catalog.id]
    track(
      selectCatalogEvent({
        catalogIds,
        attributeId: CatalogAttribute.Subcatalog,
      }),
    )

    fetchDynamicFilters({ selectedDynamicFilters, selectedFilters: { catalogIds } })
  }

  const renderNavItem = (catalog: CatalogNavigationModel) => {
    return (
      <li className="nav-item" key={catalog.id}>
        <a
          className="nav-link u-ellipsis u-block"
          href={urlWithParams(catalog.url, urlParams)}
          onClick={handleClick(catalog)}
        >
          {catalog.title}
        </a>
      </li>
    )
  }

  return (
    <>
      {subCatalogs.length > 0 && (
        <>
          <Divider />
          <Spacer size={Spacer.Size.XSmall} />
        </>
      )}
      <ul
        className="nav nav-detailed nav-page-categories"
        data-testid="sub-catalog-navigation-links"
      >
        {subCatalogs.map(renderNavItem)}
      </ul>
    </>
  )
}

export default SubcatalogNavigation
